import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class NotificationService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public notificationList(body): Observable<any> {
    return this.httpHelperService.post("/notification/list", body);
  }

  public sendReadNotification(payload: any): Observable<any> {
    return this.httpHelperService.post(`/notification/save`, payload);
  }
}
